import Vue from 'vue';
import {
  parseQuery,
  parseURL,
  getUrlParam,
  getLocation,
  formatTime,
  isWeixinBrowser
} from '@/utils';
import { getBasicComponent } from '@/components/templates/common';
import { lib } from './callapp';
/**
 * 为跳转 url 添加 webview 注入参数
 */
export function urlHandle(url) {
  const currentQueryObj = parseQuery();
  const targetUrlObj = parseURL(url);
  // 排除掉本页参数，提取需要注入的通用参数
  /* eslint-disable */
  const { code, u, ...injectQueryObj } = currentQueryObj;
  if (!injectQueryObj.token && injectQueryObj._token) {
    injectQueryObj.token = injectQueryObj._token
  }
  /* eslint-enable */
  // 注入参数对象转换为 query string
  const injectQueryString = Object.keys(injectQueryObj)
    .map(k => `${k}=${injectQueryObj[k]}`)
    .join('&');
  // 将 injectQueryString 添加到目标 query 参数中
  targetUrlObj.search = targetUrlObj.search
    ? `${targetUrlObj.search}&${injectQueryString}`
    : `?${injectQueryString}`;
  if (targetUrlObj.hash) {
    targetUrlObj.hash = targetUrlObj.hash.includes('?')
      ? `${targetUrlObj.hash}&${injectQueryString}`
      : `${targetUrlObj.hash}?${injectQueryString}`;
  }
  console.log(`jump to: ${targetUrlObj.toString()}`);
  location.href = targetUrlObj.toString();
}

export async function gotoPage(type) {
  const PREFIX = location.host.match(/-(\w)+/g) || '';
  const part_ms_url = `https://act2${PREFIX}.huolala.cn/page/202005/act_seckill_shopping/index.html`;
  switch (type) {
    // 福利中心页
    case 'visit_page': {
      const url = `https://act2${PREFIX}.huolala.cn/page/202011/act_welfare_center/index.html`;
      urlHandle(url);
      return;
    }
    // 秒杀主页
    case 'part_ms': {
      urlHandle(part_ms_url);
      return;
    }
    // 充值n笔
    case 'recharge_n':
      urlHandle(`https://uappweb${PREFIX}.huolala.cn/uapp/#/member-recharge`);
      return;
    // 充值n元
    case 'recharge_amount':
      urlHandle(`https://uappweb${PREFIX}.huolala.cn/uapp/#/member-recharge`);
      return;
    // 免费会员
    case 'vip': {
      urlHandle(`https://uappweb${PREFIX}.huolala.cn/uapp/#/userIndex`);
      break;
    }
    // 货主福利社引导页
    case 'user_wx_pub_guide':
      urlHandle(
        `https://act2${PREFIX}.huolala.cn/page/202103/user_warm_spring/index.html#/guide`
      );
      break;
    // 个人中心页
    case 'personal_information':
      // location.href = 'hlluapp://jumpto_06'; // 个人信息页
      urlHandle(`https://uappweb${PREFIX}.huolala.cn/uapp/#/industry-info`); // 角色与行业选择页
      break;
    // 车贴审查页
    case 'once_pass_sticker_check':
      urlHandle(`https://dappweb${PREFIX}.huolala.cn/#/car-sticker`);
      break;
    // 企业下单
    case 'enterprise_home':
      urlHandle(`https://eappweb${PREFIX}.huolala.cn`);
      break;
    // 小b司机认证页
    case 'hllDriverBusiness':
      urlHandle(`https://dappweb${PREFIX}.huolala.cn/driver-join`);
      break;
    // 小拉司机认证页
    case 'xlDriverBusiness':
      if (!PREFIX) {
        urlHandle('https://driver-h5.xiaolachuxing.com/join/register');
      } else {
        urlHandle('https://xl-driver-join-v-stg.huolala.cn/register');
      }
      break;
    // 小b抢单页
    case 'hllTakeOrder':
      urlHandle(`https://dappweb${PREFIX}.huolala.cn/#/startApp?url=/order`);
      break;
    // 小拉抢单页
    case 'xlTakeOrder':
      location.href('xlcx.com/home/index');
      break;
    default:
      return;
  }
}

/**
 * 是否为风控错误
 * @param {Number} ret ret code
 */
export const isRiskError = function(ret) {
  return [11017, 11018, 11019, 11038, 11039, 11020].indexOf(ret) !== -1;
};

/**
 * 是否活动准入错误
 * @param {} msg
 * @returns
 */
export const isAccessError = function(msg) {
  return ['AccessActFail'].indexOf(msg) !== -1;
};

/**
 * 是否未命中目标人群错误
 * @param {} ret res code
 * @returns boolean
 */
export const isNotMatchUserRange = function(ret) {
  return [11080, 11083].indexOf(ret) !== -1;
};

/**
 * 是否 lalamove 业务线
 * @param {*} businessType
 * @returns
 */
export const isLalamove = function(businessType) {
  return Number(businessType) === 19;
};

/**
 * 获取 location 对象
 * @param {*} isHideLoading
 * @returns
 */
export async function getLocationObj(isHideLoading = false) {
  let locationObj = {};
  const cityId = getUrlParam('city_id');
  locationObj.cityId = cityId && cityId != 0 ? cityId : null;
  if (!locationObj.cityId) {
    locationObj = await getLocation(isHideLoading);
  }
  return locationObj;
}

/**
 * px转vw
 * @param {*} p px
 * @param {*} baseWidth
 * @returns
 */
export function px2vw(p, baseWidth = 750) {
  const val = (p / baseWidth) * 100;
  return `${val}vw`;
}

/**
 * 时间格式化，默认到日期精度
 * @param {String|Number} v 时间字符串2020-12-27 00:00:00|时间戳
 * @param {String} format 格式 e.g. yyyy.MM.dd
 */
export const toDayDate = function(v, format) {
  const date = new Date(typeof v === 'string' ? v.replace(/-/g, '/') : v);
  return v ? formatTime(format || 'yyyy.MM.dd', date) : '';
};

/**
 * 分转元
 * @param {number} val 分
 * @param {number} digits
 */
export const centToYuan = function(val, digits) {
  if (typeof val !== 'number') {
    return val;
  }
  const yuan = val / 100;
  if (digits > 0) {
    return yuan.toFixed(digits);
  }
  return yuan;
};

/**
 * 是否配置组件
 * @param {*} componentConfig
 * @returns Boolean
 */
export function isConfigurationComponent(componentConfig) {
  return !componentConfig.layoutType;
}

/**
 * 是否基础组件，基础组件id范围 2000~3000
 * @param {*} componentConfig
 * @returns Boolean
 */
export function isBasicComponent(componentConfig) {
  return (
    componentConfig.componentTypeId > 2000 &&
    componentConfig.componentTypeId < 3000
  );
}

/**
 * 生成基础组件对象
 * @param {*} compData 基础组件数据
 * @param {*} actData 活动数据
 * @returns 基础组件对象
 */
export function defaultBasicComponentBuilder(compData, componentRef, actData) {
  const { componentDetail = {}, ...fields } = compData;
  return {
    ...compData,
    props: {
      ...fields,
      ...componentDetail,
      actData
    },
    component: componentRef
  };
}

function defaultActComponentBuilder(compData, actComponentRef) {
  const { componentDetail = {}, ...fields } = compData;
  return {
    ...compData,
    props: {
      ...fields,
      ...componentDetail
    },
    component: actComponentRef
  };
}

/**
 * 查找活动组件
 * @param {} componentId
 * @param {*} actComponentLib
 * @returns
 */
function findActComponent(componentId, actComponentLib) {
  return actComponentLib[componentId];
}

/**
 * 是否流式布局组件
 * @param {*} compData 组件数据
 * @returns Boolean
 */
export function isFlowComponent(compData) {
  return compData.layoutType === 'flow';
}

/**
 * 是否右上角按钮
 * @param {*} compData 组件数据
 * @returns
 */
export function isPinnedBtnComponent(compData) {
  return [2001, 2002].includes(compData.componentTypeId);
}

/**
 * 根据 componentsMetaData 生成分组的组件对象
 * @param {*} componentsMetaData
 * @param {*}
 * @returns
 */
export function resolveComponents(
  componentsMetaData,
  { actData, actComponentLib, basicComponentBuilder, actComponentBuilder }
) {
  const configurationComponents = [];
  const pinnedBtnComponentObjs = [];
  const flowComponentObjs = [];
  const positionComponentObjs = [];
  componentsMetaData.forEach(compData => {
    // 配置组件
    if (isConfigurationComponent(compData)) {
      configurationComponents.push(compData);
      return;
    }
    // 基础组件
    if (isBasicComponent(compData)) {
      let componentRef;
      try {
        componentRef = getBasicComponent(compData.componentTypeId);
      } catch (err) {
        console.error(err);
        return;
      }
      let basicComponentObj;
      if (basicComponentBuilder) {
        basicComponentObj = basicComponentBuilder(compData, componentRef);
      } else if (actData) {
        basicComponentObj = defaultBasicComponentBuilder(
          compData,
          componentRef,
          actData
        );
      } else {
        console.log('必须传入 actData 或者 basicComponentBuilder');
        return;
      }
      if (isFlowComponent(compData)) {
        flowComponentObjs.push(basicComponentObj);
        return;
      }
      if (isPinnedBtnComponent(compData)) {
        pinnedBtnComponentObjs.push(basicComponentObj);
        return;
      }
      positionComponentObjs.push(basicComponentObj);
      return;
    }
    // 活动组件
    if (!actComponentLib) {
      console.log('必须传入 actComponentLib');
      return;
    }
    const actComponentRef = findActComponent(
      compData.componentTypeId,
      actComponentLib
    );
    if (!actComponentRef) {
      console.error(`不支持的活动组件: ${compData.componentTypeId}`);
      return;
    }
    let actComponentObj;
    if (actComponentBuilder) {
      actComponentObj = actComponentBuilder(compData, actComponentRef);
    } else {
      actComponentObj = defaultActComponentBuilder(compData, actComponentRef);
    }
    if (isFlowComponent(compData)) {
      flowComponentObjs.push(actComponentObj);
      return;
    }
    positionComponentObjs.push(actComponentObj);
  });
  return [
    pinnedBtnComponentObjs,
    flowComponentObjs,
    positionComponentObjs,
    configurationComponents
  ];
}

/**
 * 业务线枚举
 */
export const BUSINESS_TYPE_NAME = {
  1: '通用',
  2: '搬家',
  3: '大货车',
  4: '货运',
  5: '零担物流',
  6: '司机会员',
  7: '企业货运',
  8: null
};

/**
 * 优惠券用途枚举
 */
export const COUNPON_PURPOSE_NAME = {
  1: '下单减免',
  2: '充值抵扣',
  3: '会员兑换',
  4: '无忧搬家',
  5: '便捷搬家'
};

export const CLIENT_TYPE_MAP = {
  0: '全部',
  1: '个人版-安卓',
  2: '个人版-IOS',
  3: '个人版-Web',
  4: '微信',
  5: '个人版-M站',
  6: '个人版-菜鸟M站',
  7: '个人版-菜鸟M站',
  8: '企业版-安卓',
  9: '企业版-IOS',
  10: '微信小程序',
  12: '百度小程序',
  13: '快应用',
  14: '支付宝小程序',
  100: '闲鱼/菜鸟'
};

/**
 * 解析券规则字段为字符串数组
 * @param {*} data
 * @returns
 */
export function resolveCouponRule(data) {
  const rules = [];
  if (data.businessType && BUSINESS_TYPE_NAME[Number(data.businessType)]) {
    rules.push(`适用业务：${BUSINESS_TYPE_NAME[Number(data.businessType)]}`);
  }
  if (data.purposeType) {
    rules.push(`适用用途：${COUNPON_PURPOSE_NAME[Number(data.purposeType)]}`);
  }
  if (data.numLimit && Number(data.numLimit) === 1) {
    rules.push('号码限制：登录号码需与联系人一致');
  }
  if (data.clientType && Number(data.clientType) !== 0) {
    const clientTypeArr = data.clientType.split(',');
    const resArr = clientTypeArr.map(val => CLIENT_TYPE_MAP[Number(val)]);
    rules.push(`适用端口(渠道)：${resArr.join(',')}`);
  }
  if (data.cityNames) {
    rules.push(`适用城市(区域)：${data.cityNames}`);
  }
  if (data.payType) {
    const val =
      Number(data.payType) === 1
        ? '所有线上支付'
        : '仅限个人余额支付或组合支付';
    rules.push(`支付限制：${val}`);
  }
  if (data.timeType || data.timePeriods) {
    let val = '';
    if (Number(data.timeType) === 1) {
      val = '全天';
    } else {
      val = (data.timePeriods || [])
        .map(obj => `${obj.startTime}~${obj.endTime}`)
        .join(',');
    }
    rules.push(`可用时段：${val}`);
  }
  if (
    Number(data.weekType) === 2 &&
    data.weekValue &&
    (Number(data.purposeType) === 5 || Number(data.purposeType) === 4)
  ) {
    const WEEK_MAP = {
      1: '周一',
      2: '周二',
      3: '周三',
      4: '周四',
      5: '周五',
      6: '周六',
      7: '周日'
    };
    const dateArr = data.weekValue.split(',');
    const newDateArr = dateArr.map(item => WEEK_MAP[Number(item)]);
    rules.push(`可用日期：${newDateArr.join(',')}`);
  }
  if (Number(data.purposeType) === 4) {
    rules.push('此券不适用于搬运费、货物保障服务费');
  }
  if (Number(data.businessType) === 4) {
    rules.push('此券不适用于大车车型，不适用于搬运费');
  }
  if (
    Number(data.purposeType) === 4 &&
    Number(data.movePackageType) === 2 &&
    data.movePackageNames
  ) {
    rules.push(`可用套餐：${data.movePackageNames}`);
  }
  return rules;
}

/**
 * 是否小拉业务线
 * @returns Boolean
 */
export function isXL() {
  return getUrlParam('bl') === '8';
}
export const DRIVER_APP_LINK = {
  102: {
    appUrl: 'xlcx.com/home/index'
  },
  101: {
    appUrl: 'xlcx.com/web/index',
    url: {
      prd: `https://driver-h5.xiaolachuxing.com/join/register?ref=${getUrlParam(
        'ref'
      )}`,
      stg: `https://xl-driver-join-v-stg.xiaolachuxing.com/register?ref=${getUrlParam(
        'ref'
      )}`,
      pre: `https://xl-driver-join-v-pre.xiaolachuxing.com/register?ref=${getUrlParam(
        'ref'
      )}`
    }
  }
};
/**
 *
 * @param {*} driverLinkId  资源位活动id
 *
 */
export async function urlDriverHandle(driverLinkId, isToast, text) {
  console.log(driverLinkId, isToast, 'urlDriverHandle');
  let activity_xl_driver_id = '';
  let linkItem = DRIVER_APP_LINK[driverLinkId];
  const host = location.hostname;
  let resiterUrl = '';
  let isStglinkUrl = /-stg/.test(host);
  if (linkItem.url) {
    if (isStglinkUrl) {
      resiterUrl = linkItem.url.stg;
    } else if (/-pre/.test(host)) {
      resiterUrl = linkItem.url.pre;
    } else {
      resiterUrl = linkItem.url.prd;
    }
  }
  console.log(resiterUrl, 'resiterUrl');
  let h5Url = linkItem.url ? resiterUrl : '';
  console.log(123123, text);
  if (isToast) {
    Vue.prototype.$hll.toast(text);
  } else {
    //  跳过小拉双登陆
    try {
      Vue.prototype.$hll.showLoading({ disableLogo: true });
      const data = await Vue.prototype.$request.post(
        '/web/drivers/encrypted_driver_id',
        {}
      );
      if (data) {
        activity_xl_driver_id = data;
      }
    } catch (error) {
      throw error;
    } finally {
      Vue.prototype.$hll.hideLoading();
    }
    h5Url = `${h5Url}&driver_id=${activity_xl_driver_id}`;
    console.log(h5Url, 'h5Url');
    if (isWeixinBrowser()) {
      if (linkItem.url) {
        location.href = h5Url;
      } else {
        Vue.prototype.$hll.toast('请在小拉出行司机APP或系统浏览器中打开');
      }
    } else {
      if (linkItem.url) {
        location.href = h5Url;
      } else {
        lib.open({ path: linkItem.appUrl });
      }
    }
  }
}
